import Insights from './insights';
import ExternalTracker from './externalTracker';
class ExternalTrackingInitializer {
    constructor(configuration) {
        this.configuration = configuration;
        if (this.configuration.siteId === undefined && this.configuration.projectId) {
            this.configuration.siteId = this.configuration.projectId;
        }
    }
    init() {
        const trackingConfig = {
            enhancedBaseUrl: this.configuration.baseUrl,
            enhancedParams: {
                projectId: this.configuration.siteId
            }
        };
        const cookiePostfix = this.configuration.addSiteToCookie ? `_${this.configuration.siteId || ''}` : '';
        const insights = new Insights(this.configuration.siteId, this.configuration.allowCookies !== undefined ? this.configuration.allowCookies : true, trackingConfig, cookiePostfix);
        insights.setHasCheckoutTracking(this.configuration.interface.hasCheckoutTracking || this.configuration.interface.productDetailPage !== undefined || this.configuration.interface.checkout !== undefined);
        new ExternalTracker(insights, this.configuration.interface);
        // @ts-ignore
        window.ZoovuSearchInsightsTracker = insights;
    }
}
if ('ss360TrackingConfiguration' in window || 'zoovuSearchTrackingConfiguration' in window) {
    // @ts-ignore
    const configuration = 'ss360TrackingConfiguration' in window ? window.ss360TrackingConfiguration : window.zoovuSearchTrackingConfiguration;
    new ExternalTrackingInitializer(configuration).init();
}
else {
    // @ts-ignore
    window.SS360Tracker = ExternalTrackingInitializer;
    // @ts-ignore
    window.ZoovuSearchTracker = ExternalTrackingInitializer;
}
